import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom';

const IntroItem = ({ intro }) => {

    const location = useLocation();

    return (
        <Fragment>
            <p className="lead">
            { intro.about }
            </p>
            <p className="lead">
            { location.pathname === '/about' && <Fragment>
                { intro.description }
            </Fragment> }
            </p>
        </Fragment>
    )
}

IntroItem.propTypes = {
    intro: PropTypes.object.isRequired,
}

export default IntroItem
